import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Geometry from '../geom/Geometry';
import Coordinate from '../geom/Coordinate';
import Point from '../geom/Point';
import Double from '../../../../java/lang/Double';
import Centroid from './Centroid';
import GeometryCollection from '../geom/GeometryCollection';
var InteriorPointPoint = /*#__PURE__*/function () {
  function InteriorPointPoint() {
    _classCallCheck(this, InteriorPointPoint);
    InteriorPointPoint.constructor_.apply(this, arguments);
  }
  _createClass(InteriorPointPoint, [{
    key: "getInteriorPoint",
    value: function getInteriorPoint() {
      return this._interiorPoint;
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments[0] instanceof Geometry) {
        var geom = arguments[0];
        if (geom instanceof Point) {
          this.add(geom.getCoordinate());
        } else if (geom instanceof GeometryCollection) {
          var gc = geom;
          for (var i = 0; i < gc.getNumGeometries(); i++) this.add(gc.getGeometryN(i));
        }
      } else if (arguments[0] instanceof Coordinate) {
        var point = arguments[0];
        var dist = point.distance(this._centroid);
        if (dist < this._minDistance) {
          this._interiorPoint = new Coordinate(point);
          this._minDistance = dist;
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._centroid = null;
      this._minDistance = Double.MAX_VALUE;
      this._interiorPoint = null;
      var g = arguments[0];
      this._centroid = Centroid.getCentroid(g);
      this.add(g);
    }
  }, {
    key: "getInteriorPoint",
    value: function getInteriorPoint(geom) {
      var intPt = new InteriorPointPoint(geom);
      return intPt.getInteriorPoint();
    }
  }]);
  return InteriorPointPoint;
}();
export { InteriorPointPoint as default };